export default () =>
  import(
    /* webpackChunkName: 'coffee/app/help-centre/invoice/description' */ './Description'
  );
